/**
 * Central registry of all patient forms.
 * To add a new form: append one entry here — no other file needs to change
 * until you also build the form component and wire it in PatientForms.jsx.
 *
 * value  — must match the selectedFormType key used in PatientForms.jsx
 * label  — display name shown in the dropdown and in the Medical settings modal
 */
const formRegistry = [
  { value: "ama",                      label: "Against Medical Advice Form" },
  { value: "referral",                 label: "Referral Form" },
  { value: "medicalCertificate",       label: "Medical Certificate" },
  { value: "accompanyingCertificate",  label: "Accompanying Certificate" },
  { value: "houseMaidHealthCheckup",   label: "House Maid Health Checkup" },
  { value: "healthFitnessCertificate", label: "Health & Fitness Certificate" },
  { value: "sickLeave",               label: "Sick Leave" },
];

export default formRegistry;
